var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn tendering-bell",class:{'tendering-bell--active': _vm.isActive},attrs:{"type":"button"},on:{"click":function($event){_vm.isActive = !_vm.isActive}}},[_c('i',{staticClass:"far fa-bell"})])}
var staticRenderFns = []

export { render, staticRenderFns }